export default __webpack_public_path__ + "static/media/ic4.0acb8367.svg";